export default function CadastroOrdemServico(){
    return "Cadastro Ordem Serviço"
}